import { api, param2query } from "./api.service";

export const getResumo = (params) => {
  return api.get(`dashboard/resumo?${param2query(params)}`);
};
